var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA11YmenuLineChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.909158 0.54546C0.909158 0.344629 0.746352 0.181824 0.545521 0.181824C0.34469 0.181824 0.181885 0.344629 0.181885 0.54546L0.181885 10.7267C0.181885 10.7269 0.181885 10.7271 0.181885 10.7273C0.181885 10.9281 0.344691 11.0909 0.545522 11.0909C0.545919 11.0909 0.546315 11.0909 0.546712 11.0909L11.4546 11.0909C11.6554 11.0909 11.8182 10.9281 11.8182 10.7273C11.8182 10.5264 11.6554 10.3636 11.4546 10.3636L0.909158 10.3636L0.909158 8.27117C0.931573 8.2511 0.951844 8.22791 0.969306 8.20172L3.45791 4.46881L5.83745 5.65859C5.99082 5.73527 6.17691 5.6944 6.28403 5.5605L8.6969 2.54442L11.0763 4.9238C11.2183 5.06581 11.4485 5.06581 11.5905 4.9238C11.7325 4.78179 11.7325 4.55155 11.5905 4.40954L8.92387 1.74288C8.85073 1.66974 8.74991 1.63121 8.64663 1.63693C8.54336 1.64265 8.4474 1.69208 8.38279 1.77284L5.89976 4.87663L3.49603 3.67476C3.332 3.59275 3.13257 3.64571 3.03085 3.7983L0.909158 6.98083L0.909158 0.54546Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA11YmenuLineChart);
export default __webpack_public_path__ + "static/media/a11ymenu_line_chart.be9deebdcbb30129588c228ef10c4455.svg";
export { ForwardRef as ReactComponent };